module.exports = __webpack_public_path__ + "static/media/isle-of-man.fb79e7ab.svg";